import React from 'react';
import { LockboxVendorSettings } from '@bb/automaton';
import { Field, ErrorMessage, FieldProps } from 'formik';

import { Select } from 'components/Select';
import { StyledTableDataContents, StyledTableDataLabel } from './styled';

type BrandSelectRowType = {
  inputName: string;
  setFieldTouched: any;
  resetFieldValues: (value: string) => void;
  lockboxVendorSettings?: LockboxVendorSettings;
};

const BrandSelectRow: React.FC<BrandSelectRowType> = ({
  inputName,
  setFieldTouched,
  resetFieldValues,
  lockboxVendorSettings,
}) => {
  const Selector: React.FC<{ field: any }> = ({
    field: { name, value, onBlur, onChange },
    children,
  }) => (
    <Select
      value={value}
      className="form-control"
      onChange={(e, ...args) => {
        resetFieldValues(e);
        onChange(e, ...args);
      }}
      onBlur={_value => {
        setFieldTouched(name);
        if (onBlur) onBlur(_value);
      }}
    >
      {children}
    </Select>
  );

  return (
    <tr>
      <StyledTableDataLabel>
        <label>Brand: </label>
      </StyledTableDataLabel>
      <StyledTableDataContents>
        <Field name={inputName}>
          {({
            field, // { name, value, onChange, onBlur }
          }: FieldProps) => (
            <Selector field={field}>
              <option value=""></option>
              {(!lockboxVendorSettings ||
                lockboxVendorSettings?.masterLock) && (
                <option value="masterLock">Master Lock</option>
              )}
              {(!lockboxVendorSettings ||
                lockboxVendorSettings?.sentriLock) && (
                <option value="sentriLock">SentriLock</option>
              )}
            </Selector>
          )}
        </Field>
        <ErrorMessage name={inputName} component="label" className="error" />
      </StyledTableDataContents>
    </tr>
  );
};

export default BrandSelectRow;
